



















import { Component, Mixins } from 'vue-property-decorator'
import VhFixMixin from '@/plugins/mixins-vh-fix'
import { Company } from '@/api/model/company'
import { ReferralType, WidgetFlowType } from '@/api/types'
import { Question } from '@/views/Form/Conversation.vue'
import Conversation from '@/views/Form/Conversation.vue'
import axios from 'axios'

const basePath = process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH || ''
const baseUrl = process.env.VUE_APP_KEYVUE_BACKEND_BASEURL
enum Score {
    LOW = -1,
    NEUTRAL = 0,
    HIGH = 1,
}

@Component({
    components: {
        Conversation,
    },
})
export default class Appraisal extends Mixins(VhFixMixin) {
    company: Company = null
    companyLoading: boolean = true
    companyError: boolean = false
    submitted: boolean = null

    async mounted() {
        await this.loadCompany()
    }

    async loadCompany(): Promise<void> {
        this.companyLoading = true

        try {
            const response = await axios.get(`${baseUrl}${basePath}/companies/` + this.$route.query.company)
            this.company = Company.fromData(response.data)
            if ('companyName' in this.$route.query && this.$route.query.companyName.length) {
                this.company.branding.displayName = this.$route.query.companyName as string
            }
            this.$root.$currentCompany = this.company
        } catch (err) {
            this.companyError = true
        } finally {
            this.companyLoading = false
        }
    }

    get isFormEnabled(): boolean {
        if (!this.company || !this.company.activatedWidgetFlowTypes.includes(WidgetFlowType.VALUATION)) {
            return false
        }

        return true
    }

    get questions(): Question[] {
        let questions: Question[] = [
            {
                question: `👋 Hoi, ik ben Emma van ${this.company.branding.displayName}. Wil jij meteen een waardebepaling van jouw woning?`,
                model: 'request',
                choices: {
                    true: 'Ja',
                    false: 'Nee',
                },
            },
        ]

        if (this.answers.request === 'false') {
            questions = [].concat(questions, [
                {
                    question: `Oké 😊. Mocht je van mening veranderen, dan kun je op de knop hieronder klikken. 👇`,
                    input: 'button',
                    inputAttrs: {
                        title: 'Toch aanvragen',
                    },
                    inputListeners: {
                        click: () => {
                            window.location.reload(true)
                        },
                    },
                },
            ])
        } else if (this.answers.request === 'true') {
            questions = [].concat(questions, [
                {
                    question: `Leuk, dan ga ik dat direct voor je in orde maken! Wat is jouw voornaam?`,
                    model: 'firstname',
                    inputAttrs: {
                        name: 'Voornaam',
                    },
                },
                {
                    question: `Oké ${this.answers.firstname}, ik heb nog een paar vragen om de waardebepaling meteen te kunnen versturen. Wat is jouw achternaam?`,
                    model: 'lastname',
                    inputAttrs: {
                        name: 'Achternaam',
                    },
                },
                {
                    question: `${this.answers.firstname} ${this.answers.lastname} staat genoteerd! ✅ Wat is de postcode van de woning?`,
                    model: 'zipcode',
                    inputAttrs: {
                        name: 'Postcode',
                        rules: 'required|zipcode',
                    },
                },
                {
                    question: `En wat is het huisnummer inclusief eventuele toevoeging?`,
                    model: 'streetnumber',
                    inputAttrs: {
                        name: 'Huisnummer',
                    },
                },
                {
                    question: `Om wat voor soort woning gaat het?`,
                    model: 'housetype',
                    choices: [
                        'Vrijstaande woning',
                        '2 onder 1 kap woning',
                        'Geschakelde 2 onder 1 kapwoning',
                        'Geschakelde woning',
                        'Tussen/rijwoning',
                        'Hoekwoning',
                        'Eindwoning',
                        'Galerijflat',
                        'Portiekflat',
                        'Corridorflat',
                        'Maisonnette',
                        'Benedenwoning',
                        'Bovenwoning',
                        'Portiekwoning',
                    ],
                },
                {
                    question: `Wat is de reden dat je een waardebepaling aanvraagt?`,
                    model: 'reason',
                    input: 'text',
                    inputAttrs: {
                        name: 'Reden',
                    },
                    choices: [
                        'Ik ga wellicht verkopen (Binnen 3 maanden)',
                        'Ik ga wellicht verkopen (Binnen 6 maanden)',
                        'Ik ga wellicht verkopen (Binnen 12 maanden)',
                        'Ik ben gewoon nieuwsgierig',
                        'Ik ben benieuwd ivm WOZ waarde',
                    ],
                },
                {
                    question: `We zijn er bijna, wat is je telefoonnummer?`,
                    model: 'phonenumber',
                    inputAttrs: {
                        name: 'Telefoonnummer',
                    },
                },
                {
                    question: `De laatste vraag ${this.answers.firstname}, naar welk e-mailadres mag de waardebepaling gestuurd worden?`,
                    model: 'email',
                    inputAttrs: {
                        name: 'E-mailadres',
                        rules: 'required|email',
                    },
                },
                {
                    question: `We hebben alles om jou binnen vijf minuten een waardebepaling te sturen. Alleen hebben wij nog conform de AVG jouw toestemming nodig om je gegevens op te mogen slaan conform de privacy voorwaarden van ${this.company.branding.displayName}. We gebruiken de gegevens alleen om te voldoen aan jouw verzoek en de opvolging daarvan.`,
                    model: 'avg',
                    choices: {
                        true: 'Ik ga akkoord',
                        false: 'Ik ga niet akkoord',
                    },
                    onValidate: (answer): true|string => {
                        if (answer === 'false') {
                            return 'We hebben jouw toestemming nodig om je een waardebepaling te sturen.'
                        }

                        return true
                    },
                    afterLeave: async (): Promise<void>  => {
                        await this.submit()
                    },
                },
            ])

            if (this.submitted === true) {
                questions = [].concat(questions, [
                    {
                        question: `Super, bedankt voor je waardebepaling aanvraag. 👍 Ik heb alle gegevens ontvangen en zal de waardebepaling spoedig opstellen en e-mailen. ✉ Nog een hele fijne dag vandaag ${this.answers.firstname}! 👋`,
                    },
                ])
            } else if (this.submitted === false) {
                questions = [].concat(questions, [
                    {
                        question: `Sorry, er is iets misgegaan. Probeer het later opnieuw.`,
                    },
                ])
            }
        }

        return questions
    }

    answers = {
        request: null,
        firstname: null,
        lastname: null,
        zipcode: null,
        streetnumber: null,
        housetype: null,
        reason: null,
        phonenumber: null,
        email: null,
        avg: null,
    }

    get score(): Score {
        switch (this.answers.reason) {
            case 'Ik ga wellicht verkopen (Binnen 3 maanden)':
            case 'Ik ga wellicht verkopen (Binnen 6 maanden)':
                return Score.HIGH

            case 'Ik ben gewoon nieuwsgierig':
            case 'Ik ben benieuwd ivm WOZ waarde':
                return Score.LOW

            case 'Ik ga wellicht verkopen (Binnen 12 maanden)':
            default:
                return Score.NEUTRAL
        }
    }

    async submit(): Promise<void> {
        this.submitted = null

        try {
            await axios.post(`${baseUrl}${basePath}/referrals/create`, {
                company: this.company.resourceIdentifier,
                source: 'emma',
                newSource: this.company.emmaSource?.resourceIdentifier,
                firstname: this.answers.firstname,
                lastname: this.answers.lastname,
                streetnumber: this.answers.streetnumber,
                zipcode: this.answers.zipcode,
                email: this.answers.email,
                phonenumber: this.answers.phonenumber,
                type: ReferralType.APPRAISAL,
                score: this.score,
                data: {
                    streetnumber: this.answers.streetnumber,
                    zipcode: this.answers.zipcode,
                    housetype: this.answers.housetype,
                    reason: this.answers.reason,
                    tag: this.$route.query.tag || null,
                    utm_source: this.$route.query.utm_source || null,
                    utm_medium: this.$route.query.utm_medium || null,
                    utm_campaign: this.$route.query.utm_campaign || null,
                    utm_term: this.$route.query.utm_term || null,
                    utm_content: this.$route.query.utm_content || null,
                    form_identifier: 'appraisal_appraisal',

                },
            })

            this.submitted = true
        } catch (err) {
            this.submitted = false
        }
    }
}
